import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp12};
`

export const Example = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  background-color: ${props => props.theme.colors.background.secondary};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp12};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  border-radius: ${props => props.theme.primitives.radius.radius1};
  word-break: break-all;
`
